import React from "react";

export function Nav({
  onNavigate,
  currentView,
  user,
  onAuthClick,
  isGame,
  gameLabel,
  gameColor,
  difficulty,
}: {
  onNavigate: (view: string) => void;
  currentView: string;
  user: { display_name: string; avatar_url: string | null } | null;
  onAuthClick: () => void;
  isGame?: boolean;
  gameLabel?: string;
  gameColor?: string;
  difficulty?: string;
}) {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 border-b border-[rgba(0,240,160,0.08)]"
      style={{ background: "rgba(13,15,28,0.92)", backdropFilter: "blur(16px)", WebkitBackdropFilter: "blur(16px)" }}>
      <div className="max-w-[1100px] mx-auto px-6 md:px-10 flex items-center gap-4 h-[52px]">
        {isGame ? (
          <>
            <button
              onClick={() => onNavigate("home")}
              className="flex items-center gap-2 text-warm-gray hover:text-electric-mint transition-colors duration-150"
            >
              <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4">
                <path fillRule="evenodd" d="M17 10a.75.75 0 01-.75.75H5.612l4.158 3.96a.75.75 0 11-1.04 1.08l-5.5-5.25a.75.75 0 010-1.08l5.5-5.25a.75.75 0 111.04 1.08L5.612 9.25H16.25A.75.75 0 0117 10z" clipRule="evenodd" />
              </svg>
              <span className="font-mono text-[9px] tracking-[2px] uppercase">Games</span>
            </button>
            <div className="w-px h-5 bg-dark-gray" />
            <span className="font-display font-bold text-sm" style={{ color: gameColor }}>
              {gameLabel}
              {difficulty && (
                <span className="font-mono font-normal text-[10px] text-warm-gray ml-2 tracking-[1px] uppercase">
                  {difficulty}
                </span>
              )}
            </span>
          </>
        ) : (
          <>
            <button onClick={() => onNavigate("home")} className="font-display font-extrabold text-base tracking-tight text-electric-mint whitespace-nowrap mr-2 flex items-center gap-2">
              <svg viewBox="0 0 52 52" fill="none" className="w-5 h-5">
                <path d="M16 20 C16 14, 22 12, 26 12 C30 12, 36 14, 36 20" stroke="#00F0A0" strokeWidth="2.5" strokeLinecap="round" fill="none"/>
                <path d="M14 28 C14 22, 18 18, 26 18 C34 18, 38 22, 38 28" stroke="#00F0A0" strokeWidth="2.5" strokeLinecap="round" fill="none"/>
                <path d="M18 36 C18 30, 22 26, 26 26 C30 26, 34 30, 34 36" stroke="#00F0A0" strokeWidth="2.5" strokeLinecap="round" fill="none"/>
                <circle cx="16" cy="20" r="3" fill="#00F0A0"/>
                <circle cx="36" cy="20" r="3" fill="#00F0A0"/>
                <circle cx="26" cy="26" r="3" fill="#00F0A0"/>
              </svg>
              neurobics<span className="font-normal opacity-40">.io</span>
            </button>

            <div className="flex items-center gap-6 overflow-x-auto">
              {[
                { key: "home", label: "Games" },
                { key: "leaderboard", label: "Leaderboard" },
              ].map(({ key, label }) => (
                <button
                  key={key}
                  onClick={() => onNavigate(key)}
                  className={`font-mono text-[9px] tracking-[2px] uppercase whitespace-nowrap transition-colors duration-150 ${
                    currentView === key ? "text-electric-mint" : "text-warm-gray hover:text-electric-mint"
                  }`}
                >
                  {label}
                </button>
              ))}
              {user && (
                <button
                  onClick={() => onNavigate("dashboard")}
                  className={`font-mono text-[9px] tracking-[2px] uppercase whitespace-nowrap transition-colors duration-150 ${
                    currentView === "dashboard" ? "text-electric-mint" : "text-warm-gray hover:text-electric-mint"
                  }`}
                >
                  Dashboard
                </button>
              )}
            </div>
          </>
        )}

        <div className="ml-auto">
          {user ? (
            <button
              onClick={() => onNavigate("dashboard")}
              className="flex items-center gap-2 text-sm text-chalk-dim hover:text-electric-mint transition-colors"
            >
              {user.avatar_url ? (
                <img src={user.avatar_url} alt="" className="w-6 h-6 rounded-full" />
              ) : (
                <div className="w-6 h-6 rounded-full bg-surface flex items-center justify-center text-xs font-display font-bold text-electric-mint">
                  {user.display_name[0]?.toUpperCase()}
                </div>
              )}
              <span className="hidden sm:inline font-display font-medium text-xs">{user.display_name}</span>
            </button>
          ) : (
            <button
              onClick={onAuthClick}
              className="font-display font-semibold text-xs px-4 py-1.5 rounded-full border border-[rgba(255,255,255,0.15)] text-chalk hover:border-electric-mint hover:text-electric-mint transition-all duration-200"
            >
              Log in
            </button>
          )}
        </div>
      </div>
    </nav>
  );
}
